import {MOON_150, MOON_500} from '@wandb/weave/common/css/globals.styles';
import styled from 'styled-components';

export const Panel = styled.div`
  margin: 12px;
`;
Panel.displayName = 'S.Panel';

export const Spacer = styled.div`
  height: 4px;
`;
Spacer.displayName = 'S.Spacer';

export const Runs = styled.div`
  max-height: 400px;
  overflow: auto;
`;
Runs.displayName = 'S.Runs';

export const Run = styled.div`
  padding: 8px;
  cursor: pointer;
  &:hover {
    background-color: ${MOON_150};
  }
`;
Run.displayName = 'S.Run';

export const RunNameRow = styled.div`
  display: inline-flex;
  align-items: flex-start;
`;
RunNameRow.displayName = 'S.RunNameRow';

export const ColorIndicator = styled.div`
  margin-top: 4px;
`;
ColorIndicator.displayName = 'S.ColorIndicator';

export const SecondRow = styled.div`
  color: ${MOON_500};
  font-size: 14px;
  white-space: nowrap;
`;
SecondRow.displayName = 'S.SecondRow';

export const NoMatches = styled.div`
  color: ${MOON_500};
  margin: 8px;
`;
NoMatches.displayName = 'S.NoMatches';
